import { CardContent } from './shared.style';
import { svgIcons } from '@exploration/icons';
import { headlessPageDataAtom } from '@exploration/ui-utils';
import { BaseCard } from '@midwest/web/card';
import { MDSTextInput } from '@midwest/web/forms';
import { InputContainer } from '@midwest/web/shared';
import { desktop } from '@thrivent/midwest-shared';
import { MDSAnchorButton } from '@thrivent/midwest-web';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { useState } from 'react';
import styled from 'styled-components';

// --------------------------------------------------------------------------

const FormContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  gap: 0.5rem;

  ${desktop} {
    flex-direction: row;
    .search-input {
      flex-grow: 1;
      padding-right: 0.5rem;
    }
  }
`;

// The card title already has the "label text" for the input, so we can just hide it
// height adjusted on input to match button height
const SearchInput = styled(MDSTextInput)`
  width: 100%;
  > div:first-of-type {
    display: none;
  }
  ${InputContainer} {
    height: 3.5rem;
  }
`;

const SearchButton = styled(MDSAnchorButton)`
  height: 3.5rem;
  width: 100%;
  width: fit-content;

  ${desktop} {
    align-self: flex-end;
  }
`;

// --------------------------------------------------------------------------

const FAForm = () => {
  const [inputValue, setInputValue] = useState('');
  const { push } = useRouter();

  const goToAdvisorPage = (url = '') => {
    let value = '';
    if (inputValue) {
      value = `?qp=${inputValue}`;
    }
    push(`${url}${value}`);
  };

  return (
    <FormContainer>
      <SearchInput
        name="search-input"
        label="Find a financial advisor"
        placeholder="Enter city, state, or ZIP code"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setInputValue(e.currentTarget.value)
        }
      />
      <SearchButton
        role="link"
        href="https://local.thrivent.com/"
        id="find-advisor-page"
        onClick={() => goToAdvisorPage('https://local.thrivent.com/')}
      >
        Search
      </SearchButton>
    </FormContainer>
  );
};

// --------------------------------------------------------------------------

export const FindFACard = ({ className }: { className?: string }) => {
  const pageData = useAtomValue(headlessPageDataAtom);
  const { text } = pageData ?? {};
  return (
    <BaseCard className={className} raised={true}>
      <CardContent
        icon={text?.['find-fa-card-icon'] as svgIcons}
        headline={text?.['find-fa-card-title']}
        subHeadline={text?.['find-fa-card-description']}
        buttonComponent={<FAForm />}
      />
    </BaseCard>
  );
};
